import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Grid
} from "@mui/material";
import useStyles from "../styles";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { httprequest } from "../../../data/api";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import NotFounditem from "../../error/NotFound";
import { useParams } from "react-router-dom";
import PageLoader from "../../../components/PageLoader";
import useValidator from "../../../hooks/useValidator";
import nosearch from "../../../assets/images/no-search.svg";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import InputGroup from "../../../components/FormComponent/InputGroup";
import BulkResultEntry from "./BulkResult";

const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const GET_CLASS_GRADES = "/api/v1/broad-sheet/";
const CLASSES_ENDPOINT = "/api/v1/class";
const GET_SUBJECT_GRADES = "/api/v1/grade/";
const CLASS_SUBJECT = "/api/v1/class-subject/";
const GET_All_STUDENTS = "/api/v1/class/students/";
const GRADING_SYSTEM = "/api/v1/grading-system";
const CLASS_TEST_RESULT = "/api/v1/ca-test/result/";
const CLASS_EXAM_RESULT = "/api/v1/school-exams/result/";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";
const BULK_GRADES_ENDPOINT = "/api/v1/grade";

const ClassResults = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [value, setValue] = useState("");
  const [classesData, setClassData] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState([]);
  const [classTestResult, setClassTestResult] = useState([]);
  const [classExamResult, setClassExamResult] = useState([]);
  // eslint-disable-next-line no-console
  console.log("classTestResult", classTestResult);
  const [obtainablescore, setObtainableScore] = useState([]);
  const [calculatedGrade, setCalculatedGrade] = useState(null);
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [resulttModal, setResultModal] = useState(false);
  const [bulkResultModal, setBulkResultModal] = useState(false);
  const [classGrades, setClassGrades] = useState([]);
  const [allFetching, setAllFetching] = useState(false);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [allClassSubject, setAllClassSubject] = useState([]);
  const [resultCreating, setResultCreating] = useState((false));
  const [autoCA, setAutoCA] = useState(false);
  const [caErrors, setCaErrors] = useState({});
  const [allStudent, setAllStudents] = useState([]);
  const [allGradingSystem, setAllGradingSystem] = useState([]);
  const [studentResultValidator, showStudentResultValidator] = useValidator();
  const caCount = obtainablescore?.[0]?.ca?.length || 0;

  // Number of fixed columns after CA columns, e.g., Total CA, Exam, Total, Grade = 4
  const fixedCols = 4;
  const colSpan = caCount + fixedCols;

  const [classResultForm, setClassResultForm] = useState({
    subject_id: "",
    class_id: id,
    student_id: "",
    CA_scores: {},
    term_id: "",
    grade: "",
    total: "",
    exam_score: "",
    CA_total: "",
    grading_system_id: "",
    grade_type: "manual"
  });

  // const handleAddSubjectModal = () => {
  //   setResultModal(!resulttModal);
  // };

  // Handle opening bulk result modal
  const handleOpenBulkResultModal = () => {
    if (!aselectedTerm) {
      toast.error("Please select a term first");

      return;
    }
    setBulkResultModal(true);
  };

  // Handle closing bulk result modal
  const handleCloseBulkResultModal = () => {
    setBulkResultModal(false);
  };

  // Get All Terms
  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
  };

  // Handle close Result Modal
  const handleCloseAddResultModal = () => {
    setResultModal(!resulttModal);
    setAutoCA(false);

    const initialCA = (obtainablescore?.[0]?.ca || []).reduce((acc, item) => {
      acc[item?.ca_type] = "";

      return acc;
    }, {});

    setClassResultForm((prev) => ({
      ...prev,
      CA_scores: initialCA,
      CA_total: "",
      grade: "",
      grading_system_id: "",
      total: "",
      exam_score: "",
      student_id: ""
    }));
    setCaErrors({});
  };

  // Handle Get all Grading System
  const handleGetAllGradingSystem = () => {
    httprequest.get(GRADING_SYSTEM).then((res) => {
      setAllGradingSystem(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };

  // Handle Select Grade system
  const handleGradeChange = (e) => {
    const selectedId = e.target.value;
    const selectedGradingSystem = allGradingSystem.find(
      (gradeSystem) => gradeSystem?.id === selectedId
    );

    setSelectedGrade(selectedGradingSystem);

    if (selectedGradingSystem && classResultForm?.total !== null) {
      const gradeDetails = selectedGradingSystem.grading.find(
        (grade) => classResultForm.total >= grade.min && classResultForm?.total <= grade.max
      );

      if (gradeDetails) {
        setCalculatedGrade(gradeDetails?.grade);
        setClassResultForm((prevForm) => ({
          ...prevForm,
          grade: gradeDetails?.grade,
          grading_system_id: selectedId
        }));
      } else {
        toast.error("Total does not fall within any grade range.");
        setClassResultForm((prevForm) => ({
          ...prevForm,
          grade: "",
          grading_system_id: ""
        }));
      }
    }
  };

  // CA SCores Input
  const handleTestScoreChange = (e, caType) => {
    const inputRaw = e.target.value;
    const inputValue = inputRaw.replace(/^0+(?=\d)/, "");

    // Get max obtainable for this caType
    const maxObtainable = obtainablescore?.[0]?.ca?.find((item) => item.ca_type === caType)?.score || 0;

    if (Number(inputValue) > maxObtainable) {
      setCaErrors((prev) => ({
        ...prev,
        [caType]: `${caType} cannot exceed ${maxObtainable}`
      }));

      return;
    } else {
      setCaErrors((prev) => ({
        ...prev,
        [caType]: ""
      }));
    }

    // Update CA_scores
    const updatedCA = {
      ...classResultForm.CA_scores,
      [caType]: inputValue
    };

    // Compute CA_total and total
    const CA_total = Object.values(updatedCA).reduce((sum, val) => sum + (Number(val) || 0), 0);
    const examScore = parseInt(classResultForm.exam_score) || 0;
    const totalScore = CA_total + examScore;

    // Determine grade
    let grade = "";
    if (selectedGrade?.grading) {
      const gradeDetails = selectedGrade.grading.find(
        (grade) => totalScore >= grade.min && totalScore <= grade.max
      );
      grade = gradeDetails ? gradeDetails.grade : "";
    }

    setClassResultForm({
      ...classResultForm,
      CA_scores: updatedCA,
      CA_total: String(CA_total),
      total: String(totalScore),
      grade
    });
  };

  // Handle Get all classes
  const getAllClasses = () => {
    httprequest
      .get(CLASSES_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setClassData(physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  // Handle Get All Session
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  const NoResultFound = () => {
    return (
      <NotFounditem
        img={nosearch}
        title="No Result Found"
        subtitle="The Name that matches this query cannot be found"
      />
    );
  };
    // Find Active Term in an Current Session
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  // Handle Session Change
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    getAllTerms(Session_ID);
  };

  // handle Get All Class Result
  const handleGetAllClassResult = async (classID, termId) => {
    setAllFetching(true);
    try {
      const res = await httprequest.get(`${GET_CLASS_GRADES}${classID}?term_id=${termId}`);
      setAllFetching(false);
      setClassGrades(res?.data?.data);
      setFilteredStudents(res?.data?.data);
    } catch (err) {
      setAllFetching(false);
      toast.error(err?.response?.message);
    }
  };

  // Create Add Student Result
  const handlePostStudentResult = () => {
    if (studentResultValidator.allValid()) {
      setResultCreating(true);
      httprequest.post(GET_SUBJECT_GRADES, { ...classResultForm, term_id: aselectedTerm }).then((res) => {
        setResultCreating(false);
        toast.success(res?.data?.message);
        handleGetAllClassResult(id, aselectedTerm);
        handleCloseAddResultModal();
      }).catch((err) => {
        setResultCreating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showStudentResultValidator(true);
    }
  };

  // Get All Subject for a Class
  const getAllSubjectForClass = async () => {
    try {
      const res = await httprequest.get(`${CLASS_SUBJECT}${id}`);
      setAllClassSubject(res?.data?.data);
    } catch (err) {
      toast.error(err?.response?.data);
    }
  };

  // Handle All Input Change
  const handleTextChange = (e) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0;

    // Copy form state
    const updatedForm = { ...classResultForm, [name]: value };

    // Check exam_score validity
    if (name === "exam_score") {
      const maxExam = obtainablescore?.[0]?.examination || 0;

      if (numericValue > maxExam) {
        toast.error(`Exam score cannot exceed ${maxExam}!`);
        updatedForm.exam_score = classResultForm?.exam_score || 0;
      }
    }

    // CA_total and exam_score to calculate the total score
    const caTotal = parseFloat(updatedForm.CA_total) || 0;
    const examScore = parseFloat(updatedForm.exam_score) || 0;
    const totalScore = caTotal + examScore;
    updatedForm.total = totalScore;

    if (totalScore > 100) {
      toast.error("Total score cannot exceed 100!");
    }

    // Calculate the grade
    let grade = "";
    if (selectedGrade?.grading) {
      const gradeDetails = selectedGrade.grading.find(
        (grade) => totalScore >= grade.min && totalScore <= grade.max
      );
      grade = gradeDetails ? gradeDetails.grade : "";
      setCalculatedGrade(grade);
    }

    updatedForm.grade = grade;
    setClassResultForm(updatedForm);
  };

  // Handle get student in a class
  const handleGetAllStudents = () => {
    httprequest.get(`${GET_All_STUDENTS}${id}`).then((res) => {
      setAllStudents(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
     * Fetches all obtainable scores from the API
     */
  const getAllObtainableScores = () => {
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data?.filter((scores) => scores?.session?.id === active_term_session?.session_id));
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const getClassTestResult = (aselectedTerm) => {
    httprequest
      .get(`${CLASS_TEST_RESULT}${id}?term_id=${aselectedTerm}`)
      .then((res) => {
        setClassTestResult(res?.data?.data);
      }).catch((err) => {
        toast.error(err?.response?.message);
      });
  };

  const getClassExamResult = (aselectedTerm) => {
    httprequest
      .get(`${CLASS_EXAM_RESULT}${id}?term_id=${aselectedTerm}`)
      .then((res) => {
        setClassExamResult(res?.data?.data);
      }).catch(() => {
        // toast.error('Error occurred');
      });
  };

  const handleStudentChange = (e) => {
    const { name, value } = e.target;
    setClassResultForm((prev) => ({ ...prev, [name]: value }));
  };

  // Handles the change event when a new term is selected
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
    handleGetAllClassResult(id, selectedTermId);
    getClassTestResult(selectedTermId);
    getClassExamResult(selectedTermId);
  };

  const filteredResults = classTestResult?.filter(item => item.student?.id === classResultForm?.student_id &&
    item?.subject?.id === classResultForm?.subject_id
  );

  const handleAutoCAChange = (e) => {
    const isChecked = e.target.checked;
    setAutoCA(isChecked);

    if (isChecked && filteredResults.length > 0) {
      const selectedResult = filteredResults[0];
      const updatedCAScores = { ...selectedResult.ca_scores };

      const totalCA = Object.values(updatedCAScores).reduce(
        (sum, score) => sum + (Number(score) || 0),
        0
      );

      setClassResultForm((prev) => ({
        ...prev,
        CA_scores: updatedCAScores,
        CA_total: String(totalCA),
        grade_type: "auto"
      }));
    } else {
      setClassResultForm((prev) => ({
        ...prev,
        CA_scores: {},
        CA_total: "",
        grade_type: "manual"
      }));
    }
  };

  // On mount renders all classes
  useEffect(() => {
    getAllClasses();
    getAllSessions();
    getAllTerms();
    handleGetAllStudents();
    getAllSubjectForClass();
    handleGetAllGradingSystem();
  }, []);

  useEffect(() => {
    if (active_term_session?.id) {
      handleGetAllClassResult(id, active_term_session.id);
      getClassTestResult(active_term_session.id);
      getClassExamResult(active_term_session.id);
      getAllObtainableScores();
    }
  }, [active_term_session]);

  useEffect(() => {
    if (obtainablescore?.[0]?.ca?.length > 0) {
      const initialCA = obtainablescore?.[0]?.ca.reduce((acc, item) => {
        acc[item?.ca_type] = "";

        return acc;
      }, {});

      setClassResultForm((prev) => ({
        ...prev,
        CA_scores: initialCA
      }));
    }
  }, [obtainablescore]);

  useEffect(() => {
    if (activeSession?.id) {
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  const handleClassChange = (event, newValue) => {
    setValue(newValue);
    getAllSubjectForClass(value);
  };

  useEffect(() => {
    if (id?.length > 0 && active_term_session?.id) {
      const params = {
        term_id: active_term_session.id
      };

      handleGetAllClassResult(id, params?.term_id);
    }
  }, [id, active_term_session]);

  const students = Array.from(
    new Map(
      (classGrades?.sheet || [])
        .flatMap((entry) => entry?.students.map((student) => [
          student.id,
          { id: student?.id, name: `${student?.last_name} ${student?.first_name}` }
        ])
        )
    ).values()
  );

  // Handle saving bulk results
  const handleSaveBulkResults = (results) => {
    // eslint-disable-next-line no-console
    console.log("results", results);
    setResultCreating(true);
    httprequest.post(BULK_GRADES_ENDPOINT, results)
      .then(() => {
        setResultCreating(false);
        toast.success(`Successfully added ${results.length} results`);
        handleGetAllClassResult(id, aselectedTerm);
        handleCloseBulkResultModal();
      })
      .catch((err) => {
        setResultCreating(false);
        toast.error(err?.response?.data?.message || "Failed to save results");
      });
  };

  const subjects = classGrades?.sheet?.map((entry) => entry.subject) || [];

  return (
    <>
      <div className={classes.headinfo}>
        <div>
          <div className={classes.resultbtn}>
            {/* <Button
              onClick={handleAddSubjectModal}
              variant="primaryoutline"
              buttonSize="fluid"
              color="btnfontprimary"
              buttonName="Add Student Result"
            /> */}
            <Button
              onClick={handleOpenBulkResultModal}
              variant="primary"
              buttonSize="fluid"
              color="btndefault"
              buttonName="Add Student Results"
            />
          </div>
          <div className="flex gap-10 align-items-end margin-top-5">
            <div>
              {activeSession?.id && (
                <SelectGroup
                  children={
                    <select
                      defaultValue={activeSession?.id}
                      onChange={handleSessionChange}
                      name="session"
                    >
                      <option value="">---Select---</option>
                      {allSessions?.map((sesh) => {
                        return (
                          <option key={sesh?.id} value={sesh?.id}>
                            {sesh?.session}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
              )}
            </div>
            <div>
              {active_term_session?.id && (
                <SelectGroup
                  children={
                    <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                      <option value="">---Select---</option>
                      {selectedSessionTerms?.map((data) => {
                        return (
                          <option key={data?.id} value={data?.id}>
                            {data?.term}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {allFetching ? (
        <PageLoader />
      ) : classGrades?.sheet?.length === 0 ? (
        <NoResultFound />
      ) : (
        <TableContainer component={Paper} style={{ overflowX: "auto" }} className={classes.tableContainer}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={`${classes.headerCell} ${classes.firstColumn}`} rowSpan={2}>Student Name</TableCell>
                {subjects.map((subject) => (
                  <>
                    <TableCell className={classes.headerCell} colSpan={colSpan} align="center">
                      {subject?.name}
                    </TableCell>
                  </>
                ))}
              </TableRow>
              <TableRow>
                {subjects.map((_, subjectIndex) => (
                  <>
                    {obtainablescore?.[0]?.ca?.map((ca) => (
                      <TableCell
                        key={ca?.ca_type}
                        className={classes.subHeaderCell}
                        align="center"
                      >
                        {ca.ca_type}
                      </TableCell>
                    ))}
                    <TableCell className={classes.subHeaderCell} align="center">
          Total CA
                    </TableCell>
                    <TableCell className={classes.subHeaderCell} align="center">
          Exam
                    </TableCell>
                    <TableCell
                      className={classes.subHeaderCell}
                      align="center"
                    >
          Total
                    </TableCell>
                    <TableCell
                      className={`${classes.subHeaderCell} ${
                        subjectIndex === subjects.length - 1 ? "" : classes.separator
                      }`}
                      align="center"
                    >
          Grade
                    </TableCell>
                  </>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {students.map((student, studentIndex) => (
                <TableRow
                  key={student?.id}
                  className={studentIndex % 2 === 0 ? "" : classes.bodyRowOdd}
                >
                  <TableCell className={classes.secondRowCol}>{student?.name}</TableCell>
                  {subjects.map((subject, subjectIndex) => {
                    // Find scores for current subject & student
                    const subjectEntry = filteredStudents?.sheet?.find(
                      (entry) => entry.subject.id === subject.id
                    );
                    const studentScores = subjectEntry?.students.find(
                      (s) => s.id === student.id
                    );

                    if (studentScores) {
                      const CA_scores = studentScores?.scores?.CA_scores || {};

                      return (
                        <>
                          {/* Render CA scores dynamically */}
                          {obtainablescore?.[0]?.ca?.map((ca) => (
                            <TableCell
                              key={ca.ca_type}
                              className={classes.bodyCell}
                              align="center"
                            >
                              {CA_scores[ca.ca_type] ?? "-"}
                            </TableCell>
                          ))}
                          <TableCell className={classes.bodyCell} align="center">
                            {studentScores?.scores?.CA_total ?? "-"}
                          </TableCell>
                          <TableCell className={classes.bodyCell} align="center">
                            {studentScores?.scores?.exam_score ?? "-"}
                          </TableCell>
                          <TableCell className={classes.bodyCell} align="center">
                            {studentScores?.scores?.total ?? "-"}
                          </TableCell>
                          <TableCell
                            className={`${classes.bodyCell} ${
                              subjectIndex === subjects.length - 1 ? "" : classes.separator
                            }`}
                            align="center"
                          >
                            {studentScores?.scores?.grade ?? "-"}
                          </TableCell>
                        </>
                      );
                    }

                    // If no scores found for student-subject combo, render empty cells
                    return (
                      <>
                        {obtainablescore?.[0]?.ca?.map((ca) => (
                          <TableCell
                            key={ca.ca_type}
                            className={classes.bodyCell}
                            align="center"
                          >
                -
                          </TableCell>
                        ))}
                        <TableCell className={classes.bodyCell} align="center">
              -
                        </TableCell>
                        <TableCell className={classes.bodyCell} align="center">
              -
                        </TableCell>
                        <TableCell className={classes.bodyCell} align="center">
              -
                        </TableCell>
                        <TableCell
                          className={`${classes.bodyCell} ${
                            subjectIndex === subjects.length - 1 ? "" : classes.separator
                          }`}
                          align="center"
                        >
              -
                        </TableCell>
                      </>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {/* Add Results */}
          <Modal
            title="Add Result"
            subtitle={
              <div>
                Manually add your student's result.
              </div>
            }
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Class"
                      required
                      children={
                        <select disabled value={id} name="class_id" onChange={handleClassChange}>
                          <option value="">--- Select ---</option>
                          {classesData?.map((class_id) => {
                            return (
                              <option key={class_id.id} value={class_id?.id}>
                                {class_id?.class_name}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {studentResultValidator.message("Class", classResultForm?.class_id, "required")}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Subject"
                      required
                      children={
                        <select name="subject_id" onChange={handleTextChange}>
                          <option value="">--- Select ---</option>
                          {allClassSubject?.map((subject) => {
                            return (
                              <option key={subject.subject_id} value={subject?.subject_id}>
                                {subject?.subject_name}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {studentResultValidator.message("Subject", classResultForm?.subject_id, "required")}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup
                      label="Students"
                      required
                      children={
                        <select name="student_id" onChange={handleStudentChange}>
                          <option value="">--- Select ---</option>
                          {allStudent?.map((student) => {
                            return (
                              <option key={student?.student?.student_id} value={student?.student?.student_id}>
                                {`${student?.student?.last_name} ${student?.student.first_name}`}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {studentResultValidator.message("Student", classResultForm?.student_id, "required")}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <label>
                      <input
                        type="checkbox"
                        disabled={filteredResults.length === 0}
                        onChange={handleAutoCAChange}
                      />
                      Add Score from CA Test
                    </label>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={2}>
                      {autoCA ? (
                        <>
                          {obtainablescore?.[0]?.ca?.map((item, index) => {
                            const existingValue = classResultForm?.CA_scores?.[item.ca_type];

                            return (
                              <Grid key={index} item lg={6} md={6} sm={12} xs={12}>
                                <InputGroup
                                  label={item?.ca_type}
                                  margin="normal"
                                  required
                                  placeHolder="Enter score"
                                  inputType="number"
                                  value={existingValue ?? ""}
                                  onChange={(e) => handleTestScoreChange(e, item.ca_type)}
                                />
                                {caErrors[item?.ca_type] && (
                                  <p className={classes.printError}>
                                    {caErrors[item?.ca_type]}
                                  </p>
                                )}
                              </Grid>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          {obtainablescore?.[0]?.ca?.map((item, index) => (
                            <Grid key={index} item lg={6} md={6} sm={12} xs={12}>
                              <InputGroup
                                label={item?.ca_type}
                                margin="normal"
                                required
                                placeHolder="Enter score"
                                inputType="number"
                                onChange={(e) => handleTestScoreChange(e, item?.ca_type)}
                                value={classResultForm?.CA_scores?.[item?.ca_type] ?? ""}
                              />
                            </Grid>
                          ))}
                        </>
                      )}
                    </Grid>
                  </Grid>
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Total CA Score"
                      margin="normal"
                      inputType="text"
                      required
                      inputName="CA_total"
                      value={classResultForm?.CA_total}
                      disabled
                    />
                    {studentResultValidator.message("CA Total", classResultForm?.CA_total, "required")}
                  </Grid>
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Exam Score"
                      margin="normal"
                      inputType="text"
                      required
                      inputName="exam_score"
                      onChange={handleTextChange}
                    />
                  </Grid>
                  <Grid item lg={4} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Total Score"
                      margin="normal"
                      inputType="text"
                      required
                      inputName="total"
                      value={classResultForm?.total || 0}
                      disabled
                    />
                    {studentResultValidator.message("Total Score", classResultForm?.total, "required")}
                  </Grid>
                  <Grid item lg={9} md={12} sm={12} xs={12}>
                    <SelectGroup
                      label="Grade System"
                      required
                      children={
                        <select name="grading_system_id" onChange={handleGradeChange}>
                          <option value="">--- Select ---</option>
                          {allGradingSystem?.map((grade_system) => {
                            return (
                              <option key={grade_system?.id} value={grade_system?.id}>
                                {grade_system?.title}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={3} md={12} sm={12} xs={12}>
                    <SelectGroup
                      label="Grade"
                      required
                      children={
                        <select disabled value={calculatedGrade || ""} name="grade" onChange={handleTextChange}>
                          <option value="">--- Select ---</option>
                          {selectedGrade?.grading?.map((grade_type) => {
                            return (
                              <option key={grade_type?.grade} value={grade_type?.grade}>
                                {grade_type?.grade}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {studentResultValidator.message("Grade", classResultForm?.grade, "required")}
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    buttonName="Add Result"
                    onClick={handlePostStudentResult}
                    isLoading={resultCreating}
                  />
                </div>
              </>
            }
            isopen={resulttModal}
            closeModal={handleCloseAddResultModal}
          />
        </TableContainer>
      )}

      {/* Reusable Bulk Result Entry Component */}
      <BulkResultEntry
        open={bulkResultModal}
        onClose={handleCloseBulkResultModal}
        classId={id}
        className={classesData?.find(c => c.id === id)?.class_name || ""}
        termId={aselectedTerm}
        termName={selectedSessionTerms?.find(term => term?.id === aselectedTerm)?.term}
        session={activeSession?.session}
        subjects={allClassSubject}
        classTestResults={classTestResult}
        classExamResults={classExamResult}
        students={allStudent.length > 0 ? allStudent : students}
        obtainableScores={obtainablescore}
        existingResults={classGrades?.sheet || []}
        gradingSystems={allGradingSystem}
        onSave={handleSaveBulkResults}
        isLoading={resultCreating}
        initialGradingSystemId={selectedGrade?.id || ""}
      />
    </>
  );
};

export default ClassResults;
